import type { OrderStatusResponse } from '../../lib/types';
import { formatEta, pickupDetails } from './statusModel';

/** Two-up detail cards: Pickup (store block) or Delivery (ship) + Order summary. */
export function StatusCards({ order }: { order: OrderStatusResponse }) {
  const ship = order.fulfilment === 'ship';
  const pickup = ship ? null : pickupDetails(order.fulfilment);

  return (
    <div className="ost-cards">
      <div className="ost-card">
        <div className="ost-card__eyebrow">{ship ? 'Delivery' : 'Pickup'}</div>
        {ship ? (
          <>
            <div className="ost-card__title">Tracked shipping</div>
            <div className="ost-card__body">
              {order.status === 'shipped' ? (
                order.tracking_url ? (
                  <>
                    Your parcel is with the carrier.
                    <br />
                    <a href={order.tracking_url} target="_blank" rel="noopener noreferrer">
                      Track your parcel
                    </a>
                  </>
                ) : (
                  'Your parcel is with the carrier. Tracking details are in your email.'
                )
              ) : (
                <>
                  {order.eta ? `Estimated dispatch ${formatEta(order.eta)}. ` : ''}
                  Tracking details arrive by email as soon as it ships.
                </>
              )}
            </div>
          </>
        ) : (
          pickup && (
            <>
              <div className="ost-card__title">{pickup.name}</div>
              <div className="ost-card__body">
                {pickup.address}
                <br />
                {pickup.hours}
              </div>
            </>
          )
        )}
      </div>

      <div className="ost-card">
        <div className="ost-card__eyebrow">Order</div>
        {order.summary.length > 0 ? (
          <ul className="ost-card__lines">
            {order.summary.map((line, i) => (
              <li key={i}>
                <span className="ost-card__line-label">
                  {line.label} ×{line.qty}
                </span>
                {line.detail && <span className="ost-card__line-detail"> · {line.detail}</span>}
              </li>
            ))}
          </ul>
        ) : (
          <div className="ost-card__body">Your full order summary is in the confirmation email.</div>
        )}
      </div>
    </div>
  );
}
